import React from 'react';
import HeroSection from '../../components/shared/HeroSection';
import ProjectHighlights from './sections/ProjectHighlights';
import DeliveredValue from './sections/DeliveredValue';
import ProjectApproach from './sections/ProjectApproach';
import Footer from '../../components/shared/Footer';

const PastProjects = () => {
  return (
    <div>
      {/* Hero Section */}
      <HeroSection 
        backgroundImage="/assets/asset-14.jpg"
        title="Past Projects"
      />

      {/* Project Highlights */}
      <ProjectHighlights />

      {/* Delivered Value */}
      <DeliveredValue />

      {/* Project Approach */}
      <ProjectApproach />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PastProjects;